module.exports = __webpack_public_path__ + "img/information_message_of_love.f07ee96.jpg";